import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    updates: [],
    features: [],
    feature_in_progress: [],
    loading: true,
    error: null
};

export const feedbackSlice = createSlice({
    name: 'feedback',
    initialState,
    reducers: {
        setFeedbackData: (state, action) => {
            return { ...state, ...action.payload, loading: false };
        },
        clearFeedback: () => {
            return initialState;
        }
    }
});

export const { setFeedbackData, clearFeedback } = feedbackSlice.actions;
export const selectFeedback = (state) => state.feedback;
export default feedbackSlice.reducer;
